module.exports = __webpack_public_path__ + "static/media/iconDingTou.9e1fc681.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/iconDingTou.png
// module id = 1767
// module chunks = 0 1